module.exports = __webpack_public_path__ + "img/nav-sentosa-orange.b9c7e2d6.svg";